import storage from 'redux-persist/lib/storage'
import { combineReducers } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import { authSlice } from '../../app/modules/auth/_redux/authSlice'
import { rowsSlice } from '../../app/modules/auth/_redux/userColumSlice'
import { editUserSlice } from '../../app/modules/user/Pages/editUser/_redux/editUserSlice'
import { addUserSlice } from '../../app/modules/user/Pages/newUser/_redux/addUserSlice'
import { layoutSlice } from '../../app/hoc/Layout/_redux/layoutSlice'
import userFilterSlice  from '../../app/modules/user/Pages/userListing/_redux/userFilterSlice'
import browserLessImageSlice from '../../app/modules/incidents/Pages/editLocalIncident/_redux/browserLessImageSlice'
import contactFilterSlice from '../../app/modules/contacts/pages/contactListing/_redux/contactFilterSlice'
import deviceFilterSlice from '../../app/modules/devices/Pages/userDeviceListing/_redux/deviceFilterSlice'
import appListFilterSlice from '../../app/modules/apps/pages/AppList/_redux/appListFilterSlice'
import usageRecordFilterSlice from '../../app/modules/usageRecords/_redux/userFilterSlice.js'
import myIncidentsFilterSlice from '../../app/modules/incidents/Pages/myIncidentsListing/_redux/myIncidentsFilterSlice'
import localIncidentsFilterSlice from '../../app/modules/incidents/Pages/localIncidentListing/_redux/localIncidentsFilterSlice'
import systemSettingsFilterSlice from '../../app/modules/systemSettings/Pages/settingListing/_redux/systemSettingsFilterSlice'
import appCategoriesFilterSlice from '../../app/modules/apps/pages/AppCategories/_redux/appCategoriesFilterSlice'
import systemRulesFilterSlice from '../../app/modules/adminTools/pages/systemRules/systemRulesListing/_redux/systemRulesFilterSlice'
import categoryFilterSlice from '../../app/modules/adminTools/pages/categoriesListing/_redux/categoryFilterSlice'
import maintenanceSlice from '../../app/modules/maintenance/_redux/maintenanceSlice'
export const userPersistConfig = {
    key: 'authToken',
    storage,
    whitelist: ['token'],
}
export const sidebarPersistConfig = {
    key: 'sideBar',
    storage,
    whitelist: ['sidebar','theme'],
}
const rootReducer = combineReducers({
    auth: persistReducer(userPersistConfig, authSlice.reducer),
    sideBar: persistReducer(sidebarPersistConfig, layoutSlice.reducer),
    userFilter: userFilterSlice,
    contactFilter:contactFilterSlice,
    deviceFilter:deviceFilterSlice,
    appListfilter:appListFilterSlice,
    systemSettingFilter:systemSettingsFilterSlice,
    usageRecordFilter:usageRecordFilterSlice,
    appCategoriesFilter:appCategoriesFilterSlice,
    categoryFilter:categoryFilterSlice,
    myIncidentsFilter:myIncidentsFilterSlice,
    localIncidentsFilter:localIncidentsFilterSlice,
    systemRulesFilter:systemRulesFilterSlice,
    rows: rowsSlice.reducer,
    editUser: editUserSlice.reducer,
    addUser: addUserSlice.reducer,
    browserLessImage: browserLessImageSlice,
    maintenance: maintenanceSlice,
})

export default rootReducer
